'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  width: 100%;\n  background: ', ';\n  box-shadow: ', ';\n  display: inline-block;\n  border-radius: 4px;\n  padding: 2px;\n  cursor: pointer;\n\n  &:hover .communityCard__hover{\n    background: linear-gradient(246.41deg, rgba(247, 97, 139, 0.3) -9.23%, rgba(42, 122, 255, 0.3) 118.44%);\n  }\n  &:hover .communityCard__meta{\n      background: ', ';\n  }\n  &:hover .communityCard__meta,\n  &:hover .communityCard__extra{\n      color: #FFF;\n  }\n'], ['\n  height: 100%;\n  width: 100%;\n  background: ', ';\n  box-shadow: ', ';\n  display: inline-block;\n  border-radius: 4px;\n  padding: 2px;\n  cursor: pointer;\n\n  &:hover .communityCard__hover{\n    background: linear-gradient(246.41deg, rgba(247, 97, 139, 0.3) -9.23%, rgba(42, 122, 255, 0.3) 118.44%);\n  }\n  &:hover .communityCard__meta{\n      background: ', ';\n  }\n  &:hover .communityCard__meta,\n  &:hover .communityCard__extra{\n      color: #FFF;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  border-radius: 4px;\n'], ['\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  border-radius: 4px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  align-self: flex-start;\n  display: block;\n  width: 100%;\n'], ['\n  align-self: flex-start;\n  display: block;\n  width: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  z-index: 2;\n  border: none;\n  background: unset;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n'], ['\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  z-index: 2;\n  border: none;\n  background: unset;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: block;\n  height: 42px;\n  width: 42px;\n'], ['\n  display: block;\n  height: 42px;\n  width: 42px;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 100%;\n  background: #F6F9FD;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: #46569F;\n  padding: 1em;\n  margin-top: 2px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  z-index: 2;\n'], ['\n  width: 100%;\n  height: 100%;\n  background: #F6F9FD;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: #46569F;\n  padding: 1em;\n  margin-top: 2px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  z-index: 2;\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin: 0.5em 0;\n  font-weight: bold;\n'], ['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin: 0.5em 0;\n  font-weight: bold;\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  color: #677897;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.8em;\n'], ['\n  color: #677897;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.8em;\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 70%;\n'], ['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 70%;\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n'], ['\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _favorite = require('../../images/favorite.svg');

var _favorite2 = _interopRequireDefault(_favorite);

var _placeholder = require('../../images/placeholder.png');

var _placeholder2 = _interopRequireDefault(_placeholder);

var _sharedStyles = require('../sharedStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var Wrap = _styledComponents2.default.div(_templateObject, _sharedStyles.linearGradient, _sharedStyles.defaultBoxShadow, _sharedStyles.linearGradient);

var Card = _styledComponents2.default.div(_templateObject2);

var Img = _styledComponents2.default.img(_templateObject3);

var Leave = _styledComponents2.default.button(_templateObject4);

var Favorite = _styledComponents2.default.img(_templateObject5);

var Meta = _styledComponents2.default.div(_templateObject6);

var Title = _styledComponents2.default.div(_templateObject7);

var Extra = _styledComponents2.default.div(_templateObject8);

var CreatedBy = _styledComponents2.default.div(_templateObject9);

var Hover = _styledComponents2.default.div(_templateObject10);

var CommunityCard = function (_Component) {
  _inherits(CommunityCard, _Component);

  function CommunityCard() {
    _classCallCheck(this, CommunityCard);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CommunityCard.prototype.render = function render() {
    var _props = this.props,
        _props$title = _props.title,
        title = _props$title === undefined ? '' : _props$title,
        _props$createdBy = _props.createdBy,
        createdBy = _props$createdBy === undefined ? '' : _props$createdBy,
        _props$src = _props.src,
        src = _props$src === undefined ? _favorite2.default : _props$src,
        _props$usage = _props.usage,
        usage = _props$usage === undefined ? '' : _props$usage,
        _props$onLeave = _props.onLeave,
        onLeave = _props$onLeave === undefined ? function () {} : _props$onLeave,
        rest = _objectWithoutProperties(_props, ['title', 'createdBy', 'src', 'usage', 'onLeave']);

    return _react2.default.createElement(
      Wrap,
      rest,
      _react2.default.createElement(
        Card,
        null,
        _react2.default.createElement(
          Leave,
          { onClick: function onClick(e) {
              return onLeave(e, title);
            } },
          _react2.default.createElement(Favorite, { src: src, alt: 'Leave Community' })
        ),
        _react2.default.createElement(Img, { src: _placeholder2.default, alt: title }),
        _react2.default.createElement(
          Meta,
          { className: 'communityCard__meta' },
          _react2.default.createElement(
            Title,
            null,
            title
          ),
          _react2.default.createElement(
            Extra,
            { className: 'communityCard__extra' },
            _react2.default.createElement(
              CreatedBy,
              null,
              createdBy
            ),
            _react2.default.createElement(
              'div',
              null,
              usage
            )
          )
        ),
        _react2.default.createElement(Hover, { className: 'communityCard__hover' })
      )
    );
  };

  return CommunityCard;
}(_react.Component);

exports.default = CommunityCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/CommunityCard/index.js
// module id = 100
// module chunks = 2